import moment from "moment";

const atendimento = (state = [], action) => {
  //console.log("ADDATENDIMENTOTESTe", action)
  switch (action.type) {
    case "ADD_ATENDIMENTO":
      return {
        type: "ADD_ATENDIMENTO",
        idatendimento: action.idatendimento,
        cliente: action.cliente,
        telefone: action.telefone,
        servico: action.servico,
        datatimeatd: action.datatimeatd,
        menubot: action.menubot,
        criticidade: action.criticidade,
        subservico: action.subservico,
        id: action.id,
        serviceatd: action.serviceatd,
        recuperation: action.recuperation,
        recuperationtime: action.recuperationtime,
        respatendente: action.respatendente,
        respclient: action.respclient,
        direction: action.direction,
        idmidia: action.idmidia,
        timecomplete: action.timecomplete,
        statusagent: action.statusagent,
        line: action.line,
        statusatd: action.statusatd,
        queueid: action.queueid,
        serverid: action.serverid,
        qtdmessage: action.qtdmessage,
        pathfile: action.pathfile,
        mcdu: action.mcdu,
        nomesubservico: action.nomesubservico,
        infoinitcall: action.infoinitcall,
        nomecliente: action.nomecliente,
        protocolo: action.protocolo,
        datatachado: state.datatachado !== undefined ? state.datatachado : "",
        idsubservico: action.idsubservico,
        acw: action.acw,
        isDialNc2: action.isDialNc2,
        arrayChannels:
          action.arrayChannels !== undefined ? action.arrayChannels : [],
        caseId: action.caseId,
        score_class: action.score_class,
        score_value: action.score_value,
        nps_call: action.nps_call,
        isTabulation: action.isTabulation,
        enterpriseAdditionalInfos: action.enterpriseAdditionalInfos
          ? action.enterpriseAdditionalInfos
          : [],
        contactAdditionalInfos: action.contactAdditionalInfos
          ? action.contactAdditionalInfos
          : [],
        lastCdrClicked: action.lastCdrClicked
          ? action.lastCdrClicked
          : { cdr: action.idatendimento, isLoading: false, isError: false },
        responsavelPor: action.responsavelPor || [],
        contactId: action.contactId || "",
      };
    case "CHANGE_RESPONSAVEL_POR":
      if (
        (Boolean(action.cdr) &&
          parseInt(state.idatendimento) === parseInt(action.cdr)) ||
        (!isNaN(parseInt(state.contactId)) &&
          !isNaN(parseInt(action.contactId)) &&
          parseInt(state.contactId) === action.contactId)
      ) {
        return {
          ...state,
          responsavelPor: action.responsavelPor,
          contactId: action.contactId || state.contactId,
        };
      } else {
        return state;
      }
    case "ADD_BATCH_RESPONSAVEL_POR":
      if (parseInt(state.idatendimento) === parseInt(action.cdr)) {
        return {
          ...state,
          responsavelPor: [
            ...action.responsavelPor,
            ...action.listaResponsavelPor,
          ],
        };
      } else {
        return state;
      }
    case "REMOVE_COMPANY_OF_RESPONSAVEL_POR":
      if (parseInt(state.idatendimento) === parseInt(action.cdr)) {
        return {
          ...state,
          responsavelPor: (state.responsavelPor || []).filter(
            (empresa) => !action.companysIds.includes(parseInt(empresa.id)),
          ),
        };
      } else {
        return state;
      }
    case "EDIT_ATENDIMENTO_VOZ":
      if (parseInt(state.idatendimento) === parseInt(action.idatendimento)) {
        return { ...state, recuperationtime: action.recuperationtime };
      } else {
        return state;
      }
    case "EDIT_ATENDIMENTO_C":
      if (state) {
        return { ...state, respclient: action.respclient };
      } else {
        return state;
      }
    case "EDIT_ATENDIMENTO_D":
      if (state) {
        return {
          ...state,
          idatendimento: action.idatendimento,
          cliente: action.cliente,
          telefone: action.telefone,
          servico: action.servico,
          datatimeatd: action.datatimeatd,
          menubot: action.menubot,
          criticidade: action.criticidade,
          subservico: action.subservico,
          serviceatd: action.serviceatd,
          recuperation: action.recuperation,
          recuperationtime: action.recuperationtime,
          respatendente: action.respatendente,
          respclient: action.respclient,
          direction: action.direction,
          idmidia: action.idmidia,
          timecomplete: action.timecomplete,
          statusagent: action.statusagent,
          line: action.line,
          serverid: action.serverid,
          statusatd: 0,
          durationstatus: action.durationstatus,
          qtdmessage: action.qtdmessage,
          pathfile: action.pathfile,
          protocolo: action.protocolo,
          datatachado: state.datatachado !== undefined ? state.datatachado : "",
          score_class: action.score_class,
          score_value: action.score_value,
          nps_call: action.nps_call,
        };
      }
    case "EDIT_ATENDIMENTO_A":
      if (state) {
        return { ...state, respatendente: action.respatendente };
      }
    case "EDIT_MENU_BOT":
      if (state) {
        return { ...state, protocolo: action.protocolo };
      }
    case "EDIT_MENU_BOT_DATA":
      if (state) {
        return { ...state, datatachado: action.datatachado };
      }
    case "EDIT_SURVEY":
      if (state) {
        if (parseInt(state.idatendimento) === parseInt(action.idatendimento)) {
          return {
            ...state,
            score_class: action.score_class,
            score_value: action.score_value,
          };
        } else {
          return state;
        }
      }
    case "EDIT_TIMEATD":
      if (state) {
        return { ...state, statusatd: action.statusatd };
      }
    case "EDIT_INFO_CLI":
      if (parseInt(state.idatendimento) === parseInt(action.id)) {
        return {
          ...state,
          cliente: action.name,
          menubot: action.arraymenubot,
          nomesubservico: action.nomesubservico
            ? action.nomesubservico
            : state.nomesubservico,
        };
      } else {
        return state;
      }
    case "EDIT_SUBJECT_MAIL":
      if (parseInt(state.idatendimento) === parseInt(action.id)) {
        return {
          ...state,
          nomesubservico: action.nomesubservico,
          servico: action.nomesubservico,
          cliente: action.nomesubservico,
        };
      } else {
        return state;
      }
    case "EDIT_NUMBERS_DISPONIBLES_CHANNEL":
      if (parseInt(state.idatendimento) === parseInt(action.idatendimento)) {
        return { ...state, arrayChannels: action.arrayChannels };
      } else {
        return state;
      }
    case "EDIT_ID_SERVICEATD":
      if (parseInt(state.idatendimento) === parseInt(action.idatendimento)) {
        return { ...state, serviceatd: action.retornoatt };
      } else {
        return state;
      }
    case "EDIT_INFO_MAIL":
      if (parseInt(state.idatendimento) === parseInt(action.idatendimento)) {
        return { ...state, cliente: action.cliente, servico: action.servico };
      } else {
        return state;
      }
    case "EDIT_ACW_CONTACT":
      if (parseInt(state.idatendimento) === parseInt(action.cdr)) {
        return { ...state, acw: true, hourAcw: moment() };
      } else {
        return state;
      }
    case "EDIT_IS_TABULATION":
      if (parseInt(state.idatendimento) === parseInt(action.cdr)) {
        return {
          ...state,
          isTabulation:
            state.isTabulation === true
              ? state.isTabulation
              : action.isTabulation,
        };
      } else {
        return state;
      }
    case "EDIT_ACW_CONTACT_DISABLED":
      if (parseInt(state.idatendimento) === parseInt(action.cdr)) {
        return { ...state, acw: false };
      } else {
        return state;
      }
    case "REMOVE_ATDUNIQUE":
      return [];
    case "CONSULTA_ATD":
      if (state) {
        return { ...state, respatendente: action.respatendente };
      }
      break;
    case "LINK_COPIED":
      if (state) {
        return { ...state, linkCopied: true };
      }
      break;
    case "CHANGE_IS_INGDESK_SUCCESS":
      if (parseInt(state.telefone) === parseInt(action.telefone)) {
        return {
          ...state,
          isInteractionIngDesk: true,
          clientId: action.clientId,
          clientName: action.clientName,
          caseId: action.caseId,
        };
      } else {
        return state;
      }
    case "EDIT_CLIENT_NAME":
      const findNumber = action.telefones.find(
        (number) => number.number.includes(state.telefone),
        // parseInt(state.telefone) === parseInt(number.number)
      );
      if (findNumber) {
        return {
          ...state,
          cliente: action.clientName,
        };
      } else {
        return state;
      }
    case "CLEAR_ATD_ALL":
      console.log("INGENIUM_INITIALLOGIN");
      return [];
    case "CHANGE_SEARCHTEXT":
      if (state) {
        return { ...state, searchText: action.searchText };
      }
      break;
    case "ADD_ENTERPRISE_ADDITIONAL_INFOS":
      if (parseInt(state.idatendimento) === parseInt(action.cdr)) {
        return {
          ...state,
          enterpriseAdditionalInfos: action.enterpriseAdditionalInfos,
        };
      }
      return state;
      break;
    case "ADD_CONTACT_ADDITIONAL_INFOS":
      if (parseInt(state.idatendimento) === parseInt(action.cdr)) {
        return {
          ...state,
          contactAdditionalInfos: action.contactAdditionalInfos,
        };
      }
      return state;
      break;
    case "CHANGE_LAST_CDR_CLICKED":
      if (parseInt(state.idatendimento) === parseInt(action.cdr)) {
        return {
          ...state,
          lastCdrClicked: action.lastCdrClicked,
        };
      }
      return state;
    case "CHANGE_EDIT_CHANNELS": {
        if (parseInt(state.idatendimento) !== parseInt(action.idCdr)) {
          return state;
        }
      
        const contactAdditionalInfos = state.contactAdditionalInfos.map(function (item) {
          if (item.indexOf("(contentWithJson)Canais:") === 0) {
            return action.contactAdditionalInfos;
          }
      
          return item;
        });
      
        return {
          ...state,
          contactAdditionalInfos,
        };
      }
    default:
      return state;
  }
};

export default atendimento;
